import React, { useRef, useState } from 'react'
import Container from './styles'
import { Button } from '../../UI'
import { BsEye, BsEyeSlashFill } from 'react-icons/bs'

const InputGroup = ({
  children,
  onChange,
  componentType,
  className,
  label,
  type,
  error,
  seterror,
  hasErrorDisplay = true,
  ...props
}) => {
  const errorRef = useRef(null)
  const [showPassword, setDisplay] = useState(false)
  return (
    <Container
      className={`input--group ${
        componentType === 'password' ? 'password--container' : ''
      } ${className ? className : ''}`}
    >
      {children ? (
        children
      ) : (
        <>
          {label && <label>{label}</label>}
          <input
            {...props}
            type={showPassword ? 'text' : type ? type : 'text'}
            onChange={(e) => {
            if(error) seterror(false)
              if (errorRef.current) errorRef.current.innerHTML = ''
              if (typeof onChange === 'function') onChange(e)
            }}
          />
          {componentType === 'password' && (
            <React.Fragment>
              {showPassword ? (
                <Button icon className={error ? 'password--icon2': 'password--icon'}>
                  <BsEye role="button" onClick={() => setDisplay(false)} />
                </Button>
              ) : (
                <Button icon className={error ? 'password--icon2': 'password--icon'}>
                  <BsEyeSlashFill
                    role="button"
                    onClick={() => setDisplay(true)}
                  />
                </Button>
              )}
            </React.Fragment>
          )}
        </>
      )}
      {hasErrorDisplay && <p className="error-msg" ref={errorRef} />}
    </Container>
  )
}

export default InputGroup
